"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemV1 = void 0;
var ItemV1 = /** @class */ (function () {
    function ItemV1(data) {
        this.itemTypes = data.ItemTypes;
        this.containmentConstraints = data.containmentConstraints;
        this.quantityConstraints = data.quantityConstraints;
        this.trackedItemTypes = data.TrackedItemTypes;
        this.itemRelationshipConstraints = data.ItemRelationshipConstraints;
        this.possibleItemDescriptionTypes = data.possibleItemDescriptionTypes;
    }
    ItemV1.prototype.getItemTypes = function () {
        return this.itemTypes;
    };
    ItemV1.prototype.getContainmentConstraints = function () {
        return this.containmentConstraints;
    };
    ItemV1.prototype.getItemRelationshipConstraints = function () {
        return this.itemRelationshipConstraints;
    };
    ItemV1.prototype.getQuantityConstraints = function () {
        return this.quantityConstraints;
    };
    ItemV1.prototype.getTrackedItemTypes = function () {
        return this.trackedItemTypes;
    };
    ItemV1.prototype.getPossibleItemDescriptionTypes = function () {
        return this.possibleItemDescriptionTypes;
    };
    return ItemV1;
}());
exports.ItemV1 = ItemV1;
//# sourceMappingURL=item.js.map